import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingFooter"] */ "/vercel/path0/src/components/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/vercel/path0/src/components/LandingNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoAnalytics"] */ "/vercel/path0/src/components/seo/SeoAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/seo/SeoCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsCarousel"] */ "/vercel/path0/src/components/seo/TestimonialsCarousel.tsx");
